<template>
    <div>
        <!-- start -->
        <DashboardLayout>
            <template #summary>
                <SummaryStatCard
                    v-for="card in summaryCards"
                    :key="card.label"
                    :label="card.label"
                    :value="card.value"
                    :tone="card.tone"
                />
            </template>
            <template #default>
        <div v-if="core.marketing_banner_src.length > 0" class="mb-4 d-flex justify-content-center">
            <b-img :src="core.marketing_banner_src" fluid alt="Responsive image"></b-img>
        </div>
        <b-card v-if="loggedIn_user_role == 1">
            <div class="d-flex justify-content-between">
                <button type="button" class="btn btn-primary mb-2 mr-2 float-left" @click="resetRepData">
                    <i class="mdi mdi-arrow-left mr-1"></i> Go back
                </button>
            </div>
        </b-card>
        <!-- end -->
        <!-- start -->
        <!-- <b-card style="" v-if="selectedFiltered_rep_details"> -->
        <b-card v-if="selected_rep_details">
            <h3>
                {{ selected_rep_details.name }}
            </h3>
            {{ selected_rep_details.email }}
        </b-card>

        <!-- end -->

        <b-card>
            <div class="d-flex justify-content-between mt-2">
                <div></div>
                <div>
                    <button v-if="loggedIn_user_role == 1" type="button" class="btn btn-danger mb-2 mr-2 float-left" @click="showAssignClientModal">
                        <i class="mdi mdi-plus mr-1"></i> Assign a client
                    </button>
                    <button type="button" class="btn btn-success mb-2 mr-2 float-left" @click="createClient">
                        <i class="mdi mdi-plus mr-1"></i> Add a client
                    </button>
                </div>
            </div>
            <div class="d-flex justify-content-between"></div>
            <b-tabs>
                <b-tab title="Linked Clients" active class="primary">
                    <simpleLayout :items_count="10">
                        <template #content>
                            <repsLinkedClientsTable />
                        </template>
                    </simpleLayout>
                </b-tab>
            </b-tabs>
        </b-card>
        <!-- end -->
            </template>
        </DashboardLayout>
        <assignClientModal v-if="show_modal" />
        <repCreateClientModal v-if="show_modal_createClient" />
    </div>
</template>

<script>
import { adminComputed, repMethods, repComputed } from "@/state/helpers";
import simpleLayout from "@/components/layout-templates/simple-layout.vue";
import repsLinkedClientsTable from "./repsLinkedClientsTable.vue";
import assignClientModal from "./repsAssignClientModal.vue";
import repCreateClientModal from "./repCreateClientModal.vue";
import DashboardLayout from "@/components/shared/DashboardLayout.vue";
import SummaryStatCard from "@/components/shared/SummaryStatCard.vue";

export default {
    components: {
        simpleLayout,
        repsLinkedClientsTable,
        assignClientModal,
        repCreateClientModal,
        DashboardLayout,
        SummaryStatCard,
    },
    data: () => ({
        show_modal: false,
        show_modal_createClient: false,
        ready: false,
        repDetails: {
            id: "",
            name: "",
            email: "",
        },
    }),
    computed: {
        ...adminComputed,
        ...repComputed,
        // Linked-clients summary above the "Linked Clients" list, derived client-side from
        // selected_rep_clients (fields: company_name, type, last_order_date, address).
        // Returns [] until the rep object is loaded — selected_rep_details defaults to []
        // (array) and becomes an object once api/reps/rep resolves, so the array check is
        // the first-paint guard. "Linked clients" goes warning when 0 to flag an unassigned
        // reseller (AC-2, UX-DR16 — non-color cue, never colour alone).
        summaryCards() {
            if (!this.selected_rep_details || Array.isArray(this.selected_rep_details)) {
                return [];
            }
            const clients = this.selected_rep_clients || [];
            const now = Date.now();
            const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
            let active = 0;
            for (let i = 0; i < clients.length; i++) {
                const lastOrder = clients[i].last_order_date;
                if (lastOrder) {
                    // MySQL datetime → Safari-safe parse (1.4 review fix).
                    const t = new Date(String(lastOrder).replace(" ", "T")).getTime();
                    if (!isNaN(t) && now - t <= THIRTY_DAYS) {
                        active++;
                    }
                }
            }
            return [
                { label: "Linked clients", value: clients.length, tone: clients.length === 0 ? "warning" : "neutral" },
                { label: "Active (30 days)", value: active, tone: "neutral" },
            ];
        },
    },
    methods: {
        ...repMethods,
        resetRepData() {
            this.setSelectedRepId(-1);
            // this.$router.push({ name: "reps" });
            //go back to prev route
            this.$router.back();
        },
        showAssignClientModal() {
            this.show_modal = true;
            this.$nextTick(() => {
                this.$bvModal.show("assignClientModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "assignClientModal") {
                        this.show_modal = false;
                        this.edit_id = -1;
                    }
                });
            });
        },
        loadRepDetails() {
            const urlParams = this.$route.params.repid;

            if (this.setSelectedRepId(urlParams)) {
                this.getSelectedRepDetails(urlParams).then(() => {});
                // this.$router.push({
                //         path: `/reps/view/client/${this.loggedIn_user_id}`,
                //         param: { ${this.loggedIn_user_id} },
                //     });
            }
            this.setFilteredSelectedRepDetails();
        },
        createClient() {
            this.show_modal_createClient = true;
            this.$nextTick(() => {
                this.$bvModal.show("repCreateclientModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "repCreateclientModal") {
                        this.show_modal_createClient = false;
                    }
                });
            });
        },
    },
    mounted() {
        //get the userId from the url
        // this.setSelectedRepId(this.$route.params.repid);

        // if (this.selected_rep_id !== -1) {
        //     this.setSelectedRepDetails(this.$route.params.repid).then(() => {
        //         //
        //     });
        //     this.setFilteredSelectedRepDetails();
        // }
        if (this.all_reps.length == 0) {
            this.setRepUsers().then(() => {
                this.loadRepDetails();
            });
        } else {
            this.loadRepDetails();
        }
    },
};
</script>

<style scoped></style>
